"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Option", {
  enumerable: true,
  get: function () {
    return _Option.default;
  }
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Option = _interopRequireDefault(require("./Option"));
var _styles = require("./styles");
var _InfoButton = _interopRequireDefault(require("../InfoButton"));
var _IconHelp = _interopRequireDefault(require("../../icons/General/IconHelp"));
var _Button = _interopRequireDefault(require("../Button"));
var _IconChevronDown = _interopRequireDefault(require("../../icons/General/IconChevronDown"));
var _List = _interopRequireDefault(require("../List"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Select = ({
  input,
  icon,
  type = 'default',
  native,
  optionsWidth,
  width,
  maxHeight,
  focus,
  customOpenstyle,
  customStyle,
  trackingEvent,
  trackingName,
  disabled,
  label,
  closeKey,
  className,
  info,
  infoPlacement = 'left',
  ...props
}) => {
  const ref = /*#__PURE__*/(0, _react.createRef)();
  const [open, toggleOpen] = (0, _react.useState)(false);
  const onClick = function () {
    toggleOpen(!open && !disabled);
    props.onOpenChange?.(!open);
  };
  const handleOpen = open => {
    toggleOpen(open);
    props.onOpenChange?.(open);
  };
  (0, _react.useEffect)(() => {
    if (closeKey) {
      handleOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeKey]);
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node = ref.current;
      if (node && node.contains(e.target)) {
        return;
      }
      handleOpen(false);
    };
    if (open) {
      const firstOption = ref.current?.querySelector('button, a, [tabindex]');
      if (firstOption) {
        firstOption.focus();
      }
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, ref]);
  const onChange = value => {
    if (props.onChange && !disabled) {
      props.onChange(value);
      handleOpen(false);
    }
  };
  const Label = (0, _jsxRuntime.jsx)(_styles.StyledLabel, {
    withInfo: Boolean(info),
    children: label
  });
  const NonNative = (0, _jsxRuntime.jsxs)(_styles.SelectWrapper, {
    ref: ref,
    className: className,
    css: theme => [_styles.styles.default, input && _styles.styles.input(theme), input && open && _styles.styles.open(theme), type === 'primary10' && _styles.styles.primary10(theme), icon && _styles.styles.withIcon, type === 'opacity08' && _styles.styles.opacity08(theme), width && _styles.styles.width(width), maxHeight && _styles.styles.maxHeight(maxHeight), customStyle && customStyle, open && customOpenstyle && customOpenstyle, disabled && _styles.styles.disabled(theme)],
    "aria-expanded": open,
    "aria-label": label ? label : 'Select',
    children: [input && label && Label, info && (0, _jsxRuntime.jsx)("span", {
      css: _styles.styles.infoButton,
      children: (0, _jsxRuntime.jsx)(_InfoButton.default, {
        icon: (0, _jsxRuntime.jsx)(_IconHelp.default, {
          primary: true
        }),
        place: infoPlacement,
        children: info
      })
    }), (0, _jsxRuntime.jsx)(_Button.default, {
      nostyle: true,
      afterIcon: (0, _jsxRuntime.jsx)(_IconChevronDown.default, {
        flipVertical: open,
        size: 14
      }),
      onClick: onClick,
      beforeIcon: icon,
      autoFocus: focus,
      trackingName: trackingName,
      trackingEvent: trackingEvent,
      tabIndex: disabled ? -1 : undefined,
      children: props.selectedValue ? props.selectedValue : props.text || ''
    }), (0, _jsxRuntime.jsx)(_styles.OptionsWrapper, {
      css: [input && _styles.styles.inputstyle(!!label), optionsWidth && _styles.styles.optionsWidth(optionsWidth), process.env.NODE_ENV === "production" ? "" : ";label:NonNative;"],
      children: open ? (0, _jsxRuntime.jsx)(_List.default, {
        selectList: true,
        children: props.children.filter(x => x).map((child, key) => {
          if (!child) {
            return null;
          }
          return /*#__PURE__*/_react.default.cloneElement(child, {
            onChange: onChange,
            key
          });
        })
      }) : null
    })]
  });
  const Native = (0, _jsxRuntime.jsx)("select", {
    className: className,
    css: theme => [_styles.styles.default, input && _styles.styles.input(theme), input && open && _styles.styles.open(theme), type === 'primary10' && _styles.styles.primary10(theme), icon && _styles.styles.withIcon],
    value: props.selectedValue ? props.selectedValue : props.text || '',
    onChange: e => onChange(e.target.value),
    children: props.children.filter(x => x).map((child, key) => {
      if (!child) {
        return null;
      }
      return (0, _jsxRuntime.jsx)("option", {
        value: child.props.value,
        children: child.props.children
      }, key);
    })
  });
  return native ? Native : NonNative;
};
var _default = exports.default = Select;